import * as React from 'react';
import { Codebook } from '@api/models/codebook.models';
import { CodebookApi } from '@api/Codebook.api';

export type FetchSpecialtiesCodebooks = {
  specialties: Codebook[];
  loading: boolean;
  loaded: boolean;
};
export const useFetchSpecialtiesCodebooks = (): FetchSpecialtiesCodebooks => {
  const [specialties, setSpecialties] = React.useState<Codebook[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [loaded, setLoaded] = React.useState<boolean>(false);

  React.useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        setLoading(true);
        const res = await CodebookApi.getSpecialties();
        setSpecialties(res.data);
        setLoaded(true);
      } catch (error) {
        console.error(
          'Error for useFetchSpecialtiesCodebooks -> CodebookApi.getSpecialties()',
          error
        );
      } finally {
        setLoading(false);
        setLoaded(true);
      }
    };
    fetchData();
  }, []);
  return { specialties, loading, loaded };
};
